import { EntityActionState } from '../../../Common/EntityState/EntityActionState';

export enum JuridictionIdentifierTypeEnum {
    National = 0,
    Provincial = 1,
    Municipal = 2,
    International = 3,
    Internal = 4
}

export interface IdentifierTypeViewModel extends EntityActionState {
    id: number;
    name?: string | null;
    description?: string | null;
    juridictionType: JuridictionIdentifierTypeEnum;
    isForLegalPerson: boolean;
    isForJuridicalPerson: boolean;
    identifierMask?: string | null;
    validationRegex?: string | null;
    isActive: boolean;
    isDeleted: boolean;
}

export interface IdentifierTypeCreateCommand {
    name?: string | null;
    description?: string | null;
    juridictionType: JuridictionIdentifierTypeEnum;
    isForNaturalPerson: boolean;
    isForJuridicalPerson: boolean;
    identifierMask?: string | null;
    validationRegex?: string | null;
    isActive: boolean;
}

export interface IdentifierTypeUpdateCommand extends IdentifierTypeCreateCommand {
    id: number;
}
